import { render, staticRenderFns } from "./TemplateCollection.vue?vue&type=template&id=198d98ea&scoped=true"
import script from "./TemplateCollection.vue?vue&type=script&lang=js"
export * from "./TemplateCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d98ea",
  null
  
)

export default component.exports